/* yoclay-cache-bust 20260925103200 */
/**
 * Preços de pack YoClay — multi-kit (Kit Salva Tédio + Pockets Botânicos + Pockets Pets).
 *
 * Checkout Yampi — desconto pack:
 * - A Yampi aplica as regras de desconto progressivo no painel (só nos pockets).
 * - No carrinho Shopify o tema só EXIBE o desconto visual por família.
 * - Não usar mais cupons Shopify (/discount/YOCLAY-*) nem ?promocode= na URL.
 */
(function () {
  if (typeof window === 'undefined') return;

  var PACK_CONFIGS = {
    'kit-salva-tedio': {
      handle: 'kit-salva-tedio',
      unitCents: 4990,
      totals: { 1: 4990, 3: 11990, 6: 18990 },
      discounts: { 3: 2980, 6: 10950 },
      discountCodes: { 3: 'YOCLAY-PACK-3', 6: 'YOCLAY-PACK-6' },
      noticeTitle: function (size) {
        return size === 1
          ? 'Kit Salva Tédio — 1 Pocket'
          : 'Kit Salva Tédio — Pack de ' + size + ' Pockets';
      }
    },
    'pockets-botanicos': {
      handle: 'pockets-botanicos',
      unitCents: 4990,
      totals: { 1: 4990, 3: 11990, 6: 18990 },
      discounts: { 3: 2980, 6: 10950 },
      discountCodes: { 3: 'YOCLAY-BOT-PACK-3', 6: 'YOCLAY-BOT-PACK-6' },
      noticeTitle: function (size) {
        return size === 1
          ? 'Pockets Botânicos — 1 Pocket'
          : 'Pockets Botânicos — Pack de ' + size + ' Pockets';
      }
    },
    'yoclay-pockets-edicao-limitada-de-natal': {
      handle: 'yoclay-pockets-edicao-limitada-de-natal',
      unitCents: 6990,
      totals: { 1: 6990, 3: 16990, 6: 26990 },
      discounts: { 3: 3980, 6: 14950 },
      discountCodes: { 3: 'YOCLAY-NATAL-PACK-3', 6: 'YOCLAY-NATAL-PACK-6' },
      noticeTitle: function (size) {
        return size === 1
          ? 'Pockets de Natal — 1 Pocket'
          : 'Pockets de Natal — Pack de ' + size + ' Pockets';
      }
    },
    'pockets-pets': {
      handle: 'pockets-pets',
      unitCents: 6990,
      totals: { 1: 6990, 3: 16990, 6: 26990 },
      discounts: { 3: 3980, 6: 14950 },
      discountCodes: { 3: 'YOCLAY-PETS-PACK-3', 6: 'YOCLAY-PETS-PACK-6' },
      noticeTitle: function (size) {
        return size === 1
          ? 'Pockets Pets — 1 Pocket'
          : 'Pockets Pets — Pack de ' + size + ' Pockets';
      }
    }
  };

  // Back-compat aliases used by existing callers
  var PACK_HANDLE = 'kit-salva-tedio';
  var POCKET_UNIT_CENTS = PACK_CONFIGS[PACK_HANDLE].unitCents;
  var PACK_TOTALS = PACK_CONFIGS[PACK_HANDLE].totals;
  var PACK_DISCOUNTS = PACK_CONFIGS[PACK_HANDLE].discounts;
  var DISCOUNT_CODES = PACK_CONFIGS[PACK_HANDLE].discountCodes;
  var LEGACY_PACK_CODE_RE = /YOCLAY-(?:BOT-|PETS-|NATAL-)?PACK-[36]/i;

  function getConfig(handle) {
    if (handle && PACK_CONFIGS[handle]) return PACK_CONFIGS[handle];
    return PACK_CONFIGS[PACK_HANDLE];
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
      } catch (e) {
        /* fallback */
      }
    }
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function cartUrl() {
    return (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
  }

  function getDiscountApplyUrl() {
    // Cupons Shopify de pack foram descontinuados — desconto real na Yampi.
    return cartUrl();
  }

  function getLineProperties(item) {
    if (!item || !item.properties) return {};
    if (Array.isArray(item.properties)) {
      var map = {};
      item.properties.forEach(function (entry) {
        if (entry && entry.name) {
          map[entry.name] = entry.value != null ? String(entry.value) : '';
        }
      });
      return map;
    }
    if (typeof item.properties === 'object') {
      return item.properties;
    }
    return {};
  }

  function inferPackSizeFromLabel(label) {
    if (!label) return 0;
    var match = String(label).match(/Pack\s*(?:de\s*)?(\d+)/i);
    return match ? parseInt(match[1], 10) || 0 : 0;
  }

  function getPackSizeFromItem(item) {
    var props = getLineProperties(item);
    return parseInt(props._yoclay_pack_size, 10) || inferPackSizeFromLabel(props['Pack YoClay']) || 0;
  }

  function getPackHandleFromItem(item) {
    var props = getLineProperties(item);
    if (props._yoclay_pack && PACK_CONFIGS[props._yoclay_pack]) {
      return props._yoclay_pack;
    }
    if (inferPackSizeFromLabel(props['Pack YoClay']) > 0) {
      return PACK_HANDLE;
    }
    return null;
  }

  function isPackItem(item) {
    return !!getPackHandleFromItem(item);
  }

  function isPackLine(item, size, handle) {
    if (!isPackItem(item)) return false;
    if (handle && getPackHandleFromItem(item) !== handle) return false;
    if (!size) return true;
    return getPackSizeFromItem(item) === size;
  }

  function countPackUnits(items, packSize, handle) {
    var total = 0;
    if (!items) return 0;
    items.forEach(function (item) {
      if (isPackLine(item, packSize, handle)) {
        total += item.quantity || 1;
      }
    });
    return total;
  }

  function distributeCents(totalCents, count) {
    var base = Math.floor(totalCents / count);
    var remainder = totalCents - base * count;
    var prices = [];
    var i;
    for (i = 0; i < count; i++) {
      prices.push(base + (i < remainder ? 1 : 0));
    }
    return prices;
  }

  function isLegacyPackDiscountTitle(title) {
    return LEGACY_PACK_CODE_RE.test(String(title || ''));
  }

  function cartHasLegacyPackDiscount(cart) {
    if (!cart) return false;
    var apps = cart.cart_level_discount_applications || [];
    var i;
    for (i = 0; i < apps.length; i++) {
      if (isLegacyPackDiscountTitle(apps[i].title || apps[i].code || '')) return true;
    }
    var codes = cart.discount_codes || [];
    for (i = 0; i < codes.length; i++) {
      var code = typeof codes[i] === 'string' ? codes[i] : codes[i] && codes[i].code;
      if (isLegacyPackDiscountTitle(code)) return true;
    }
    return false;
  }

  var yoclayPackVisualSuppressRefresh = false;

  function clearLegacyPackDiscountCodes(cart) {
    if (!cartHasLegacyPackDiscount(cart)) {
      return Promise.resolve(cart);
    }
    var attemptKey = 'yoclay-pack-discount-cleared-v2';
    if (sessionStorage.getItem(attemptKey) === '1') {
      return Promise.resolve(cart);
    }
    sessionStorage.setItem(attemptKey, '1');
    yoclayPackVisualSuppressRefresh = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (nextCart) {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return nextCart;
        }
        return nextCart;
      })
      .catch(function () {
        return cart;
      })
      .then(function (result) {
        yoclayPackVisualSuppressRefresh = false;
        return result;
      });
  }

  function analyzeAllCompletePacks(cart) {
    if (!cart || !cart.items || !cart.items.length) return [];

    var groups = {};
    cart.items.forEach(function (item, index) {
      var handle = getPackHandleFromItem(item);
      if (!handle) return;
      var cfg = getConfig(handle);
      var size = getPackSizeFromItem(item);
      if (!cfg.totals[size]) return;

      var key = handle + ':' + size;
      if (!groups[key]) {
        groups[key] = {
          handle: handle,
          size: size,
          quantity: 0,
          indices: [],
          lineSubtotalCents: 0
        };
      }
      groups[key].quantity += item.quantity || 1;
      groups[key].indices.push(index);
      groups[key].lineSubtotalCents += item.final_line_price || item.line_price || 0;
    });

    var packs = [];
    Object.keys(groups).forEach(function (key) {
      var group = groups[key];
      if (group.quantity !== group.size) return;
      var cfg = getConfig(group.handle);
      packs.push({
        handle: group.handle,
        size: group.size,
        quantity: group.quantity,
        indices: group.indices,
        packTotalCents: cfg.totals[group.size],
        discountCents: cfg.discounts[group.size] || 0,
        retailTotalCents: cfg.unitCents * group.size,
        lineSubtotalCents: group.lineSubtotalCents,
        discountCode: cfg.discountCodes[group.size],
        savingsCents: Math.max(0, cfg.unitCents * group.size - cfg.totals[group.size])
      });
    });

    return packs;
  }

  function computeVisualCartPricing(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return {
        packs: [],
        lineOverrides: {},
        lineOverridesByKey: {},
        displayTotalCents: 0,
        savingsCents: 0
      };
    }

    var packs = analyzeAllCompletePacks(cart);
    var lineOverrides = {};
    var lineOverridesByKey = {};
    var savingsCents = 0;

    packs.forEach(function (pack) {
      if (pack.size <= 1 || !pack.savingsCents) return;
      var cfg = getConfig(pack.handle);
      var unitPrices = distributeCents(pack.packTotalCents, pack.size);
      var priceIndex = 0;
      savingsCents += pack.savingsCents;

      pack.indices.forEach(function (idx) {
        var item = cart.items[idx];
        var qty = item.quantity || 1;
        var slice = unitPrices.slice(priceIndex, priceIndex + qty);
        priceIndex += qty;
        if (slice.length !== qty) return;

        var lineTotal = slice.reduce(function (sum, cents) {
          return sum + cents;
        }, 0);
        var override = {
          index: idx,
          key: item.key,
          handle: pack.handle,
          size: pack.size,
          displayLineCents: lineTotal,
          retailLineCents: cfg.unitCents * qty,
          unitDisplayCents: qty > 0 ? Math.round(lineTotal / qty) : lineTotal,
          unitRetailCents: cfg.unitCents,
          savingsCents: cfg.unitCents * qty - lineTotal
        };
        lineOverrides[idx] = override;
        if (item.key) lineOverridesByKey[item.key] = override;
      });
    });

    var displayTotalCents = 0;
    cart.items.forEach(function (item, idx) {
      if (lineOverrides[idx]) {
        displayTotalCents += lineOverrides[idx].displayLineCents;
      } else {
        displayTotalCents += item.final_line_price || item.line_price || 0;
      }
    });

    return {
      packs: packs,
      lineOverrides: lineOverrides,
      lineOverridesByKey: lineOverridesByKey,
      displayTotalCents: displayTotalCents,
      savingsCents: savingsCents
    };
  }

  function setMoneyHtml(el, cents, compareCents) {
    if (!el) return;
    if (compareCents != null && compareCents > cents) {
      el.innerHTML =
        '<span class="product-price__compare theme-money">' +
        formatMoney(compareCents) +
        '</span> <span class="product-price__reduced theme-money">' +
        formatMoney(cents) +
        '</span>';
    } else {
      el.innerHTML = '<span class="theme-money">' + formatMoney(cents) + '</span>';
    }
  }

  function hideLegacyPackDiscountLabels(root) {
    var scope = root || document;
    scope.querySelectorAll('.cart-discount').forEach(function (li) {
      var text = (li.textContent || '').trim();
      if (isLegacyPackDiscountTitle(text)) {
        li.hidden = true;
      }
    });
  }

  function applyVisualPackPricingToDom(cart) {
    if (!cart) return null;
    var pricing = computeVisualCartPricing(cart);
    hideLegacyPackDiscountLabels(document);

    document.querySelectorAll('[data-yoclay-cart-line-handle][data-yoclay-pack-line="true"]').forEach(function (row) {
      var key = row.getAttribute('data-key');
      var override = key ? pricing.lineOverridesByKey[key] : null;
      if (!override) {
        var lineAttr = row.querySelector('[data-line]');
        var lineNum = lineAttr && parseInt(lineAttr.getAttribute('data-line'), 10);
        if (lineNum) override = pricing.lineOverrides[lineNum - 1];
      }
      if (!override) return;

      var priceEl = row.querySelector('.price');
      var totalEl = row.querySelector('.total');
      var summaryPrice = row.querySelector('.cart-summary__price');
      if (priceEl) {
        setMoneyHtml(priceEl, override.unitDisplayCents, override.unitRetailCents);
      }
      if (summaryPrice) {
        setMoneyHtml(summaryPrice, override.displayLineCents, override.retailLineCents);
      }
      if (totalEl) {
        setMoneyHtml(totalEl, override.displayLineCents, override.retailLineCents);
      }
    });

    document.querySelectorAll('[data-yoclay-cart-item]').forEach(function (row) {
      var key = row.getAttribute('data-key');
      var override = key ? pricing.lineOverridesByKey[key] : null;
      if (!override) return;
      var priceEl = row.querySelector('.yoclay-cart-drawer__item-price');
      if (!priceEl) return;
      if (override.retailLineCents > override.displayLineCents) {
        priceEl.innerHTML =
          '<span class="yoclay-cart-drawer__item-price--current">' +
          formatMoney(override.displayLineCents) +
          '</span><span class="yoclay-cart-drawer__item-price--compare">' +
          formatMoney(override.retailLineCents) +
          '</span>';
      } else {
        priceEl.textContent = formatMoney(override.displayLineCents);
      }
    });

    document
      .querySelectorAll(
        '[data-yoclay-cart-total], .total__amount .theme-money, .cart-summary__total-price-row .theme-money'
      )
      .forEach(function (el) {
        el.textContent = formatMoney(pricing.displayTotalCents);
      });

    document.querySelectorAll('[data-yoclay-pack-cart-savings]').forEach(function (host) {
      if (pricing.savingsCents > 0) {
        host.hidden = false;
        host.textContent =
          'Você economiza ' + formatMoney(pricing.savingsCents) + ' nos packs de Pockets';
      } else {
        host.hidden = true;
        host.textContent = '';
      }
    });

    var notice = document.getElementById('yoclay-pack-cart-notice');
    if (notice) {
      var primary = pricing.packs
        .filter(function (p) {
          return p.size > 1;
        })
        .sort(function (a, b) {
          return b.size - a.size;
        })[0];
      if (primary) {
        renderPackCartNotice(notice, primary, pricing);
      } else {
        notice.hidden = true;
      }
    }

    return pricing;
  }

  function yoclayLogPackPricingForYampi(label, cartPayload, pack) {
    try {
      console.info('[YoClay Pack Yampi] ' + label, {
        packHandle: pack && pack.handle,
        packSize: pack && pack.size,
        packTotalCents: pack && pack.packTotalCents,
        total_price: cartPayload && cartPayload.total_price,
        note: 'payload sem rewrite — desconto na Yampi'
      });
    } catch (e) {
      /* ignore */
    }
  }

  function analyzePack(cart) {
    var packs = analyzeAllCompletePacks(cart);
    if (!packs.length) return null;
    return packs.sort(function (a, b) {
      return b.size - a.size;
    })[0];
  }

  function analyzeSalvaTedioPack(cart) {
    return analyzePack(cart);
  }

  function cartHasPackDiscount(cart, size, handle) {
    var pack = analyzePack(cart);
    if (!pack) return false;
    if (handle && pack.handle !== handle) return false;
    if (size && pack.size !== size) return false;
    return pack.size > 1 && pack.savingsCents > 0;
  }

  function resolvePackDiscountCodeForYampi() {
    return null;
  }

  function applyPackPricingForYampi(cartPayload) {
    if (cartPayload && window.__yoclayYampiDebug) {
      yoclayLogPackPricingForYampi('pass-through (sem rewrite)', cartPayload, analyzePack(cartPayload));
    }
    return cartPayload;
  }

  function detectActivePackHandle() {
    var builder = document.querySelector('[data-yoclay-pocket-pack-builder]');
    if (builder) {
      var handle = builder.getAttribute('data-pack-handle');
      if (handle && PACK_CONFIGS[handle]) return handle;
    }
    return PACK_HANDLE;
  }

  function getRetailTotalCents(size, handle) {
    var cfg = getConfig(handle || detectActivePackHandle());
    return cfg.unitCents * size;
  }

  function getSavingsCents(size, handle) {
    var cfg = getConfig(handle || detectActivePackHandle());
    if (cfg.discounts[size]) return cfg.discounts[size];
    return 0;
  }

  function getPackTotalCents(size, handle) {
    var cfg = getConfig(handle || detectActivePackHandle());
    return cfg.totals[size] || 0;
  }

  function initPackBuilderSizePrices() {
    var handle = detectActivePackHandle();
    var cfg = getConfig(handle);
    document.querySelectorAll('[data-yoclay-pack-size-pricing]').forEach(function (wrap) {
      var size = parseInt(wrap.getAttribute('data-yoclay-pack-size-pricing'), 10);
      if (!cfg.totals[size]) return;

      var priceEl = wrap.querySelector('[data-yoclay-pack-card-price]');
      var retailEl = wrap.querySelector('[data-yoclay-pack-card-retail]');
      var savingsEl = wrap.querySelector('[data-yoclay-pack-card-savings]');
      var compareWrap = wrap.querySelector('.yoclay-pocket-pack-builder__size-compare');
      var packTotal = cfg.totals[size];
      var retailTotal = cfg.unitCents * size;
      var savings = cfg.discounts[size] || 0;
      var isUnit = size === 1;

      if (priceEl) priceEl.textContent = formatMoney(packTotal);

      if (isUnit) {
        if (compareWrap) compareWrap.hidden = true;
        if (savingsEl) savingsEl.textContent = 'Preço unitário';
        return;
      }

      if (compareWrap) compareWrap.hidden = false;
      if (retailEl) retailEl.textContent = formatMoney(retailTotal);
      if (savingsEl) savingsEl.textContent = 'Economize ' + formatMoney(savings);
    });
  }

  function renderPackCartNotice(notice, pack, visualPricing) {
    if (!notice) return;
    notice.hidden = false;
    notice.classList.remove('yoclay-pack-cart-notice--warning');

    var titleEl = notice.querySelector('[data-yoclay-pack-notice-title]');
    var detailEl = notice.querySelector('[data-yoclay-pack-notice-detail]');
    var savingsEl = notice.querySelector('[data-yoclay-pack-notice-savings]');
    var warnEl = notice.querySelector('[data-yoclay-pack-discount-warning]');
    var cfg = getConfig(pack.handle);
    var savings = (visualPricing && visualPricing.savingsCents) || pack.savingsCents || 0;

    if (warnEl) warnEl.hidden = true;

    if (titleEl) {
      titleEl.textContent = cfg.noticeTitle(pack.size);
    }

    if (detailEl) {
      detailEl.textContent =
        (pack.size === 1 ? 'Preço unitário: ' : 'Preço do pack: ') +
        formatMoney(pack.packTotalCents) +
        (pack.size > 1 ? ' (desconto do pack)' : '');
    }

    if (savingsEl) {
      if (savings > 0) {
        savingsEl.hidden = false;
        savingsEl.textContent =
          'Você economiza ' + formatMoney(savings) + ' em relação ao preço avulso.';
      } else {
        savingsEl.hidden = true;
        savingsEl.textContent = '';
      }
    }
  }

  function ensurePackDiscountOnCartPage() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        return clearLegacyPackDiscountCodes(cart).then(function (nextCart) {
          applyVisualPackPricingToDom(nextCart || cart);
          return nextCart || cart;
        });
      })
      .catch(function () {
        /* silencioso */
      });
  }

  function bindCartAjaxRefresh() {
    if (window.__yoclayPackVisualCartBound) return;
    window.__yoclayPackVisualCartBound = true;

    document.addEventListener('cart:updated', function () {
      ensurePackDiscountOnCartPage();
    });

    function scheduleVisualRefresh() {
      if (yoclayPackVisualSuppressRefresh) return;
      setTimeout(ensurePackDiscountOnCartPage, 350);
    }

    // Reaplica após fetch (drawer / add AJAX).
    if (!window.__yoclayPackVisualFetchPatched && typeof window.fetch === 'function') {
      window.__yoclayPackVisualFetchPatched = true;
      var _fetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var promise = _fetch(input, init);
        if (/\/cart\/(change|update|add|clear)/.test(String(url))) {
          promise
            .then(function (res) {
              if (res && res.ok) scheduleVisualRefresh();
              return res;
            })
            .catch(function () {
              /* ignore */
            });
        }
        return promise;
      };
    }

    // Tema Boost usa jQuery $.ajax em /cart/change.js.
    if (window.jQuery && !window.__yoclayPackVisualAjaxBound) {
      window.__yoclayPackVisualAjaxBound = true;
      window.jQuery(document).ajaxComplete(function (_event, _xhr, settings) {
        var url = (settings && settings.url) || '';
        if (/\/cart\/(change|update|add)/.test(url)) {
          scheduleVisualRefresh();
        }
      });
    }
  }

  window.yoclayApplyPackPricingForYampi = applyPackPricingForYampi;

  window.yoclayPackPricing = {
    PACK_HANDLE: PACK_HANDLE,
    PACK_CONFIGS: PACK_CONFIGS,
    POCKET_UNIT_CENTS: POCKET_UNIT_CENTS,
    PACK_TOTALS: PACK_TOTALS,
    PACK_DISCOUNTS: PACK_DISCOUNTS,
    DISCOUNT_CODES: DISCOUNT_CODES,
    formatMoney: formatMoney,
    getConfig: getConfig,
    getPackTotalCents: getPackTotalCents,
    getRetailTotalCents: getRetailTotalCents,
    getSavingsCents: getSavingsCents,
    getDiscountApplyUrl: getDiscountApplyUrl,
    analyzePack: analyzePack,
    analyzeAllCompletePacks: analyzeAllCompletePacks,
    analyzeSalvaTedioPack: analyzeSalvaTedioPack,
    cartHasPackDiscount: cartHasPackDiscount,
    computeVisualCartPricing: computeVisualCartPricing,
    applyVisualPackPricingToDom: applyVisualPackPricingToDom,
    applyPackPricingForYampi: applyPackPricingForYampi,
    resolvePackDiscountCodeForYampi: resolvePackDiscountCodeForYampi,
    initPackBuilderSizePrices: initPackBuilderSizePrices,
    ensurePackDiscountOnCartPage: ensurePackDiscountOnCartPage,
    clearLegacyPackDiscountCodes: clearLegacyPackDiscountCodes,
    countPackUnits: countPackUnits,
    distributeCents: distributeCents
  };

  window.yoclayResolvePackDiscountCodeForYampi = resolvePackDiscountCodeForYampi;

  function initPackPricing() {
    initPackBuilderSizePrices();
    ensurePackDiscountOnCartPage();
    bindCartAjaxRefresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPackPricing);
  } else {
    initPackPricing();
  }
})();
